import { Button } from '../../components/ui/button';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../../components/ui/dialog';
import Fancybox from '../../lib/FancyBox';
import VideoCipherPlayer from '../../components/solution/VideoCipherPlayer';
import { FileArrowDownIcon, VideoCameraIcon } from '@phosphor-icons/react';
import { useState } from 'react';

function isVideoCipherSession(item) {
  return item?.videoProvider === 'vc';
}

export default function LectureSessions({ packId, lectureTitle, sessions }) {
  const [selectedRecording, setSelectedRecording] = useState(null);
  const user = JSON.parse(localStorage.getItem('userProfile'));

  const sendWebengageEvent = (item) => {
    window.webengage?.track?.('Watched Lecture Recording', {
      'User Id': user?.email,
      'Pack Id': packId,
      'Lecture Title': lectureTitle,
      'Session Title': item?.title,
      'Session Id': item?._id,
    });
  };

  const openVcRecording = (item) => {
    sendWebengageEvent(item);
    setSelectedRecording(item);
  };

  const renderRecordingAction = (item) => (
    <>
      {item?.pdfLink ? (
        <Button
          variant={'outline'}
          className={'flex flex-row !bg-[var(--q3-surface-default)] rounded-full'}
          onClick={() => window.open(item.pdfLink, '_blank')}
        >
          <FileArrowDownIcon className="text-[var(--q3-danger-normal)]" />
          PDF
        </Button>
      ) : null}

      {isVideoCipherSession(item) ? (
        <Button
          variant={'outline'}
          className={'!bg-[var(--q3-surface-default)] rounded-full'}
          onClick={() => openVcRecording(item)}
        >
          Watch Now
        </Button>
      ) : (
        <Fancybox>
          <a
            href={`https://www.youtube.com/embed/${item?.recordingVideoId}`}
            data-fancybox
            data-type="iframe"
            className="relative block w-fit overflow-hidden"
            onClick={() => sendWebengageEvent(item)}
          >
            <Button variant={'outline'} className={'!bg-[var(--q3-surface-default)] rounded-full'}>
              Watch Now
            </Button>
          </a>
        </Fancybox>
      )}
    </>
  );

  if (!Array.isArray(sessions) || sessions.length === 0) return null;

  return (
    <div className="flex flex-col gap-4">
      <Dialog open={!!selectedRecording} onOpenChange={(open) => !open && setSelectedRecording(null)}>
        <DialogContent
          className="max-h-[90vh] w-[min(92vw,896px)] gap-0 overflow-hidden border-[var(--q3-stroke-normal)] bg-[var(--q3-surface-default)] p-0 sm:max-w-[min(896px,92vw)]"
          onOpenAutoFocus={(e) => e.preventDefault()}
        >
          {selectedRecording ? (
            <>
              <DialogHeader className="border-b border-[var(--q3-stroke-normal)] px-5 py-4 text-left">
                <DialogTitle className="pr-8 text-base font-semibold leading-snug text-[var(--q3-neutral-default)]">
                  {selectedRecording?.title}
                </DialogTitle>
                {selectedRecording?.description ? (
                  <p className="text-sm text-[var(--q3-neutral-light)]">{selectedRecording.description}</p>
                ) : null}
              </DialogHeader>
              <div className="px-5 pb-5 pt-4">
                <VideoCipherPlayer
                  key={selectedRecording?._id}
                  videoId={selectedRecording?.recordingVideoId}
                  isSolution={false}
                  autoLoad
                  skipInternalTracking
                />
              </div>
            </>
          ) : null}
        </DialogContent>
      </Dialog>

      {sessions.map((item) => (
        <div
          key={item?._id || item?.recordingVideoId || item?.title}
          className="flex w-full flex-row items-center justify-between rounded-xl border border-[var(--q3-stroke-normal)] bg-[var(--q3-surface-default)] p-3"
        >
          <div className="flex flex-row items-center">
            <VideoCameraIcon size={20} className="mx-4 text-[var(--q3-danger-normal)]" />
            <div className="flex flex-col gap-2">
              <p className="font-medium">{item?.title}</p>
              {item?.description ? <p className="text-xs text-[var(--q3-neutral-light)]">{item.description}</p> : null}
              <div className="flex flex-row gap-2 lg:hidden">{renderRecordingAction(item)}</div>
            </div>
          </div>
          <div className="hidden flex-row gap-2 lg:flex">{renderRecordingAction(item)}</div>
        </div>
      ))}
    </div>
  );
}
